import { convertCurrency } from '../util';
import { paymentProviders } from '../util/constants';
import useCardDetails from './useCardDetails';
import useRates from './useRates';
import { calculateFeesAndDiscounts } from '../util';
import useEarlyLateFeesDetails from './useEarlyLateFeesDetails';

const convertOrgCurrencyInPaymentCurrency = (fee, orgCurrency, paymentCurrency, rates) => {
  if (orgCurrency === paymentCurrency) {
    return fee;
  }

  return convertCurrency(fee, orgCurrency, paymentCurrency, rates);
};

const summaryFeesInfo = (
  orgPaymentData,
  paymentType,
  orgCurrency,
  paymentCurrency,
  amount,
  rates,
) => {
  let valuesWithFees = {};
  const feeData = orgPaymentData?.fees?.find(fee => fee.type === paymentType);

  if (!feeData || amount === 0) {
    return valuesWithFees;
  }

  const fixedFee =
    (feeData.fixedFee &&
      +convertOrgCurrencyInPaymentCurrency(
        +feeData.fixedFee,
        orgCurrency,
        paymentCurrency,
        rates,
      ).toFixed(2)) ||
    0;
  const variablePercentageFee = +feeData.variablePercentageFee || 0;

  const feePercentageDecimal = variablePercentageFee / 100;
  const amountOfvariablePercentageFee = Number((feePercentageDecimal * amount).toFixed(2));
  const amountWithVariablePercentageFee = Number(
    (amount + amountOfvariablePercentageFee).toFixed(2),
  );

  valuesWithFees = {
    fixedFee: fixedFee,
    variablePercentageFee: variablePercentageFee,
    amountOfvariablePercentageFee,
    amountWithVariablePercentageFee,
    amountWithFixedFee: fixedFee + amount,
    amountWithBothTypeOfFees: amount + fixedFee + amountOfvariablePercentageFee,
  };

  return valuesWithFees;
};

function useTotalWithOrWithoutFees(
  paymentType,
  amount,
  orgCurrency,
  paymentCurrency,
  invoices,
  provider = paymentProviders.stripe,
) {
  const rates = useRates();
  const cardDetails = useCardDetails(provider);
  const {
    doWeSetEarlyPaymentsInAccountingSystem,
    doWeSetLateFeesInAccountingSystem,
  } = useEarlyLateFeesDetails();

  const summaryFInfo = summaryFeesInfo(
    cardDetails,
    paymentType,
    orgCurrency,
    paymentCurrency,
    amount,
    rates,
  );

  const [totalFeesCents] = calculateFeesAndDiscounts(invoices || [], 'fee');
  const [totalDiscountsCents] = calculateFeesAndDiscounts(invoices || [], 'discount');

  const totalDiscountValueWithCondition = !doWeSetEarlyPaymentsInAccountingSystem
    ? totalDiscountsCents / 100
    : 0;
  const totalFeesValueWithCondition = !doWeSetLateFeesInAccountingSystem ? totalFeesCents / 100 : 0;

  const amountWithInvoiceAdjustments =
    amount + (totalFeesValueWithCondition - totalDiscountValueWithCondition);

  if (
    provider === paymentProviders.stripe &&
    summaryFInfo &&
    (summaryFInfo.fixedFee || summaryFInfo.variablePercentageFee)
  ) {
    return (
      summaryFInfo.fixedFee +
      summaryFInfo.amountWithVariablePercentageFee +
      (totalFeesValueWithCondition - totalDiscountValueWithCondition)
    );
  }

  return amountWithInvoiceAdjustments;
}

export { summaryFeesInfo };
export default useTotalWithOrWithoutFees;
